export enum PaymentErrors {
  NoRepeatedMessageBody = "No Repeated response message body",
  NoPaymentResponseInTransaction = "No payment response in transaction status",
  UnknownPaymentFailure = "Unknown Payment failure",
  UnknownPaymentResult = "Unkonw Payment result",
  UnknownTransactionResult = "Unkown Transaction result",
  UnknownFailureTransactionCondition = "Unknown Failure transaction result",
  UnknownAdyenResponse = "Unknown Adyen response",
  RequiredDeviceInfoMissing = "Required device info missing",
}
